/* Stone pages UI v6 (Mat's design, 2026-10-08). Reads window.CustomeaStoneData (colours + prices)
 * and window.CustomeaStoneEngine (the 3D planner's benchtop estimate engine + the website's bridge),
 * both from assets/stone-engine.js, built by stone/sync.mjs. This file renders and collects input
 * only: every figure comes from the engine, and every rate a customer reads is incl. GST
 * (v10: no ex-GST figure anywhere on the three pages; the ex-GST working is in the team email only).
 * Estimate only. Nothing here touches the cart. */
(function () {
  "use strict";
  var D = window.CustomeaStoneData;
  var E = window.CustomeaStoneEngine;
  if (!D || !E) return;
  var W = E.website;
  var T = W.TRAY;
  var WW = W.WEBSITE_WORDS;

  /* ── helpers ─────────────────────────────────────────── */
  var COLOURS = D.colours.slice().sort(function (a, b) { return a.sort - b.sort; });
  var BY_HANDLE = {};
  COLOURS.forEach(function (c) { BY_HANDLE[c.handle] = c; });
  /* Mat's design names the four tones; the colour data keeps White / Veined / Concrete / Dark. */
  var TONES = [["White", "White & plain"], ["Veined", "Veined"], ["Concrete", "Concrete"], ["Dark", "Grey & dark"]];
  var FINISH = { P: "Polished", H: "Honed", CN: "Concrete", R: "Rough", OR: "Original Rough" };
  var SAMPLES_URL = "https://www.caesarstone.com.au/caesarstone-samples/";
  var PLANNER_URL = "https://planner.customea.com.au";
  var TERMS_URL = "https://cdn.shopify.com/s/files/1/0642/0925/6643/files/Stone_T_Cs.pdf?v=1716431712";
  var DISCLAIMER = "Estimate only. Our team confirms the final price after checking your plan and a site template.";
  var MAX = W.MAX_CUTOUT_COUNT;

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (ch) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch];
    });
  }
  function aud(v) { return E.formatAud(v); }
  function incAud(ex) { return E.formatAud(E.incGst(ex)); }
  function m2(s) { return String(s).replace(/\bsqm\b/g, "m²"); }
  function q(name) { try { return new URLSearchParams(window.location.search).get(name); } catch (e) { return null; } }
  function isPreview() { return !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== "main"); }
  /* Shopify drops preview_theme_id from the address bar after the first load, so fall back to the theme's own id */
  function previewSuffix(url) {
    var id = q("preview_theme_id") || (isPreview() && Shopify.theme.id ? String(Shopify.theme.id) : "");
    return id ? url + (url.indexOf("?") >= 0 ? "&" : "?") + "preview_theme_id=" + encodeURIComponent(id) : url;
  }
  /* While the colour entries are drafts and the theme is unpublished, the colour and configurator
     pages are reached through alternate templates of /pages/benchtop; on the live theme they are their own URLs. */
  function colourUrl(c) {
    return isPreview() ? previewSuffix("/pages/benchtop?view=stone-colour&colour=" + encodeURIComponent(c.handle)) : "/pages/caesarstone/" + encodeURIComponent(c.handle);
  }
  function configUrl(handle) {
    var tail = handle ? "colour=" + encodeURIComponent(handle) : "";
    return isPreview() ? previewSuffix("/pages/benchtop?view=benchtop-configurator" + (tail ? "&" + tail : "")) : "/pages/benchtop-configurator" + (tail ? "?" + tail : "");
  }
  function collectionUrl(range) {
    var u = "/pages/benchtop" + (range ? "?range=" + range.toLowerCase() : "");
    return isPreview() ? previewSuffix(u) : u;
  }
  function sized(url, w) {
    if (!url) return "";
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, "$1width=" + w);
    return url + (url.indexOf("?") >= 0 ? "&" : "?") + "width=" + w;
  }
  function cardImage(c) { var i = c.images; return (i.closeup || i.slab || i.thumb || {}).url; }
  function fromRate(c) { return Math.min.apply(null, c.thicknesses.map(function (t) { return c.ratesExGst[t]; })); }
  function finishWords(c) { return FINISH[c.finish] || c.finish; }
  function material(c) { return c.range === "Porcelain" ? "porcelain" : "mineral"; }
  /* the name customers see: ICON colours (8251, 8252) are Caesarstone ICON, priced on the Mineral 20 mm rows (range stays Mineral) */
  function seriesOf(c) { return c.series || c.range; }
  function thickWords(c) { return c.thicknesses.join(" or ") + " mm"; }
  function store(key, val) { try { if (val === undefined) return JSON.parse(localStorage.getItem(key) || "null"); localStorage.setItem(key, JSON.stringify(val)); } catch (e) { return null; } }
  function bandsOf(range) { return range === "Porcelain" ? E.PORCELAIN_BANDS_EX_GST : E.BENCHTOP_BANDS_EX_GST; }
  function tileHtml(c) {
    return '<a class="cs-tile" href="' + esc(colourUrl(c)) + '">' +
      '<div class="cs-tile__img"><img loading="lazy" src="' + esc(sized(cardImage(c), 600)) + '" alt="Caesarstone ' + esc(c.code + " " + c.name) + '" width="600" height="600"><span class="cs-tile__cta">VIEW COLOUR</span></div>' +
      '<div><div class="cs-tile__name">' + esc(c.name) + '</div><div class="cs-tile__sub">' + esc(c.code + " · " + seriesOf(c) + " " + thickWords(c)) + "</div></div></a>";
  }
  /* Caesarstone's own edge profile drawings (caesarstone.com.au, 189 x 86 px), shown as the colour page's "Edge detail".
     Pencil Round for the standard edge; Pencil Round Mitred, Caesarstone's drawing closest to Double Mitred, for the chunky edge. */
  var EDGE_DRAWINGS = {
    standard: { src: "https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-edge-pencil-round.png", name: "Pencil Round" },
    chunky: { src: "https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-edge-pencil-round-mitred.png", name: "Pencil Round Mitred" },
  };
  /* edge profile drawings, from the design */
  function edgeSvg(chunky, w) {
    return chunky
      ? '<svg width="' + (w || 72) + '" height="44" viewBox="0 0 72 44" fill="none" aria-hidden="true"><path class="cs-prof" d="M2 4 H68 V40 H2 Z" stroke-width="1.2"/><path d="M44 22 H68" stroke="currentColor" stroke-width="0.8" stroke-dasharray="2 2"/></svg>'
      : '<svg width="' + (w || 72) + '" height="44" viewBox="0 0 72 44" fill="none" aria-hidden="true"><path class="cs-prof" d="M2 12 H62 Q70 12 70 20 Q70 28 62 28 H2 Z" stroke-width="1.2"/></svg>';
  }

  /* ── 1. collection ───────────────────────────────────── */
  function initCollection(root) {
    var range = (q("range") || "").toLowerCase() === "porcelain" ? "Porcelain" : "Mineral";
    var toneIds = TONES.map(function (t) { return t[0]; });
    var tone = toneIds.indexOf(q("tone")) >= 0 ? q("tone") : "All";
    /* the hero is the in-situ kitchen in Mat's design (rendered by the section from Shopify Files); the card names
       the stone in the photo, Caesarstone 506 Mirabel, and links to its colour page */
    var hero = BY_HANDLE["506-mirabel"] || COLOURS[0];
    var heroBox = root.querySelector("[data-cs-hero-img]");
    if (!heroBox.querySelector("img")) {
      var heroImg = hero.images.closeup || hero.images.slab || hero.images.thumb;
      heroBox.innerHTML = '<img src="' + esc(sized(heroImg.url, 1200)) + '" alt="Caesarstone ' + esc(hero.code + " " + hero.name) + '" width="' + (heroImg.width || 1200) + '" height="' + (heroImg.height || 1200) + '">';
    }
    var card = root.querySelector("[data-cs-hero-card]");
    card.setAttribute("href", colourUrl(hero));
    card.innerHTML = '<span class="cs-hc-k">SHOWN · ' + esc(hero.code) + " · " + esc(hero.range.toUpperCase()) + '</span><span class="cs-hc-n">' + esc(hero.name) + '</span><span class="cs-hc-p">' + (hero.thicknesses.length > 1 ? "from " : "") + incAud(fromRate(hero)) + " <span>per m² incl. GST</span></span>";
    var minM = Math.min.apply(null, E.BENCHTOP_BANDS_EX_GST), minP = Math.min.apply(null, E.PORCELAIN_BANDS_EX_GST);
    root.querySelector("[data-cs-stats]").innerHTML =
      '<div class="cs-stat"><span class="cs-label">Mineral, 20 mm</span><span class="cs-stat__v">from ' + incAud(minM) + "<small> /m²</small></span></div>" +
      '<div class="cs-stat"><span class="cs-label">Porcelain, 12 mm</span><span class="cs-stat__v">from ' + incAud(minP) + "<small> /m²</small></span></div>" +
      '<div class="cs-stat"><span class="cs-label">All prices</span><span class="cs-stat__v">incl. GST</span></div>';
    var mEdge = E.edgesFor("mineral")[0];
    root.querySelector("[data-cs-bandcard]").innerHTML = '<div class="cs-label">What goes into every price</div>' +
      '<div class="cs-band__row"><span>Mineral stone, 20 mm</span><b>from ' + incAud(minM) + " /m²</b></div>" +
      '<div class="cs-band__row"><span>Porcelain stone, 12 mm</span><b>from ' + incAud(minP) + " /m²</b></div>" +
      '<div class="cs-band__row"><span>' + esc(mEdge.label) + " edge</span><b>" + incAud(mEdge.pricePerMExGst) + " /m</b></div>" +
      '<div class="cs-band__row"><span>Site template fee, every job</span><b>' + incAud(E.SITE_TEMPLATE_FEE_EX_GST) + "</b></div>" +
      '<div class="cs-band__row"><span>Minimum charge</span><b>' + E.MINIMUM_STONE_SQM + " m² of stone</b></div>";
    root.querySelectorAll("[data-cs-template-fee]").forEach(function (el) { el.textContent = incAud(E.SITE_TEMPLATE_FEE_EX_GST); });
    root.querySelectorAll("[data-cs-config-link]").forEach(function (a) { a.setAttribute("href", configUrl()); });
    var rangeWrap = root.querySelector("[data-cs-ranges]");
    var chipWrap = root.querySelector("[data-cs-chips]");
    var tiers = root.querySelector("[data-cs-tiers]");
    var count = root.querySelector("[data-cs-count]");
    function render() {
      rangeWrap.innerHTML = ["Mineral", "Porcelain"].map(function (r) {
        var n = COLOURS.filter(function (c) { return c.range === r; }).length;
        return '<button type="button" data-cs-range="' + r + '" aria-pressed="' + (r === range) + '">' + r + " · " + n + "</button>";
      }).join("");
      chipWrap.innerHTML = [["All", "All"]].concat(TONES).map(function (t) {
        return '<button type="button" class="cs-chip" data-cs-tone="' + t[0] + '" aria-pressed="' + (tone === t[0]) + '">' + esc(t[1]) + "</button>";
      }).join("");
      var porcelain = range === "Porcelain";
      var total = 0;
      /* each price tier lists the range's own colours, then any series sold under its own name at that price (ICON), under a small heading */
      tiers.innerHTML = bandsOf(range).map(function (rate) {
        var inTier = COLOURS.filter(function (c) { return c.range === range && fromRate(c) === rate && (tone === "All" || c.tone === tone); });
        var groups = [];
        inTier.forEach(function (c) {
          var key = c.series || "";
          var g = groups.filter(function (x) { return x.key === key; })[0];
          if (!g) { g = { key: key, list: [] }; groups.push(g); }
          g.list.push(c);
        });
        groups.sort(function (a, b) { return (a.key ? 1 : 0) - (b.key ? 1 : 0); });
        total += inTier.length;
        return groups.map(function (g) {
          return '<div class="cs-tier' + (g.key ? " cs-tier--series" : "") + '">' + (g.key ? '<div class="cs-tier__series">' + esc(g.key) + "</div>" : "") +
            '<div class="cs-tier__head"><div><span class="cs-tier__price">' + (porcelain ? "from " : "") + incAud(rate) + '</span><span class="cs-tier__unit">per m² incl. GST' + (porcelain ? ", 12 mm" : "") + '</span></div><span class="cs-tier__count">' + g.list.length + (g.list.length === 1 ? " COLOUR" : " COLOURS") + '</span></div><div class="cs-grid">' + g.list.map(tileHtml).join("") + "</div></div>";
        }).join("");
      }).join("") || '<p class="cs-note">No ' + esc(range) + " colours in this tone. Try another.</p>";
      count.textContent = total + " " + range + " colour" + (total === 1 ? "" : "s") + " · grouped by price, lowest first";
      try {
        var u = new URL(window.location.href);
        u.searchParams.set("range", range.toLowerCase());
        if (tone === "All") u.searchParams.delete("tone"); else u.searchParams.set("tone", tone);
        history.replaceState(null, "", u.toString());
      } catch (e) {}
    }
    root.addEventListener("click", function (ev) {
      var r = ev.target.closest("[data-cs-range]");
      if (r) { range = r.getAttribute("data-cs-range"); render(); return; }
      var t = ev.target.closest("[data-cs-tone]");
      if (t) { tone = t.getAttribute("data-cs-tone"); render(); }
    });
    render();
  }

  /* ── 2. colour page ──────────────────────────────────── */
  /* the colour entry's own images, written by sections/stone-colour.liquid when the page has a metaobject; null otherwise */
  function entryImages(root) {
    var el = root.querySelector("[data-cs-entry-images]");
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function initColour(root) {
    var c = BY_HANDLE[root.getAttribute("data-handle") || q("colour") || ""];
    if (!c) {
      root.innerHTML = '<div class="cs-wrap" style="padding:80px var(--cs-gutter)"><h1 style="font-size:36px">Colour not found</h1><p class="cs-muted" style="margin:12px 0 24px">That Caesarstone colour is not on our list.</p><a class="cs-btn cs-btn--ghost" href="' + esc(collectionUrl()) + '">Show all colours</a></div>';
      return;
    }
    var mat = material(c);
    var thickness = c.thicknesses[0];
    var edge = "standard";
    var L = 3000, Dp = 600;
    /* gallery: close-up, the kitchen photo from this colour's own page on caesarstone.com.au, Caesarstone's drawing of the
       edge selected below, and the full slab. A missing image has no thumbnail at all (never a placeholder box).
       On the colour's own page (/pages/caesarstone/<handle>) the section passes the entry's images, and they win over the
       built data, so an image added to or removed from the entry in Shopify shows up by itself. */
    var imgs = entryImages(root) || c.images;
    var stone = imgs.closeup || imgs.slab || c.images.thumb;
    var views = [];
    if (stone) views.push({ label: imgs.closeup ? "Close-up" : "Full slab", src: stone.url, alt: stone.alt });
    if (imgs.kitchen) views.push({ label: "Kitchen photo", src: imgs.kitchen.url, alt: imgs.kitchen.alt || "Kitchen with a Caesarstone " + c.code + " " + c.name + " benchtop" });
    views.push({ label: "Edge detail", edge: true });
    if (imgs.closeup && imgs.slab) views.push({ label: "Full slab", src: imgs.slab.url, alt: imgs.slab.alt });
    var view = 0, zoom = false;
    var related = COLOURS.filter(function (x) { return seriesOf(x) === seriesOf(c) && x.handle !== c.handle && fromRate(x) === fromRate(c); }).slice(0, 10);
    var priceFrom = c.range === "Porcelain" ? "from " : "";
    root.innerHTML =
      '<div class="cs-wrap">' +
      '<nav class="cs-crumbs" aria-label="Breadcrumb"><a href="' + esc(collectionUrl()) + '">Stone benchtops</a><span>/</span><a href="' + esc(collectionUrl(c.range)) + '">' + esc(seriesOf(c)) + "</a><span>/</span><span>" + esc(c.name) + "</span></nav>" +
      '<section class="cs-product">' +
      '<div class="cs-gallery"><div class="cs-gallery__main" data-cs-main></div><div class="cs-gallery__thumbs" data-cs-thumbs></div></div>' +
      '<div class="cs-panel">' +
      '<div><div class="cs-eyebrow">Caesarstone ' + esc(seriesOf(c)) + "</div><h1>" + esc(c.name) + '</h1><div class="cs-panel__meta">' + esc(c.code + " · " + finishWords(c) + " · " + thickWords(c)) + "</div></div>" +
      '<div class="cs-price"><span class="cs-price__fig" data-cs-rate></span><span class="cs-price__unit">per m² incl. GST</span></div>' +
      (c.thicknesses.length > 1 ? '<div class="cs-block"><span class="cs-block__title">Thickness</span><div class="cs-two" data-cs-thicks></div></div>' : "") +
      '<div class="cs-block"><div class="cs-block__head"><span class="cs-block__title">Edge profile</span></div><div class="cs-two" data-cs-edges></div><p class="cs-fine cs-hidden" data-cs-edge-note></p></div>' +
      '<div class="cs-quick"><div class="cs-block__head"><span class="cs-block__title">Quick price, one straight run</span><span class="cs-fine">front edge polished</span></div>' +
      '<div class="cs-two"><label class="cs-field">Length, mm<input class="cs-input" type="number" inputmode="numeric" min="' + W.RUN_LENGTH_MM[0] + '" max="' + W.RUN_LENGTH_MM[1] + '" step="10" value="3000" data-cs-ql></label>' +
      '<label class="cs-field">Depth, mm<input class="cs-input" type="number" inputmode="numeric" min="' + W.RUN_DEPTH_MM[0] + '" max="' + W.RUN_DEPTH_MM[1] + '" step="10" value="600" data-cs-qd></label></div>' +
      '<div class="cs-lines" data-cs-qlines></div>' +
      '<div class="cs-total"><span class="cs-total__label">Estimate, incl. GST</span><span class="cs-total__fig" data-cs-qtotal></span></div>' +
      '<p class="cs-fine" data-cs-qnote></p></div>' +
      '<div class="cs-actions"><a class="cs-btn" href="' + esc(configUrl(c.handle)) + '">Price my whole benchtop</a>' +
      '<a class="cs-btn cs-btn--ghost" href="' + SAMPLES_URL + '" target="_blank" rel="noopener">Order a free sample</a>' +
      '<a class="cs-plannerlink" href="' + PLANNER_URL + '">Already planned in our 3D planner? Your benchtop is priced there.</a></div>' +
      "</div>" +
      '<div class="cs-specs"><div class="cs-eyebrow">Specifications</div><div class="cs-specs__grid">' +
      '<div class="cs-specs__row"><span>Range</span><span>Caesarstone ' + esc(seriesOf(c)) + "</span></div>" +
      '<div class="cs-specs__row"><span>Code</span><span>' + esc(c.code) + "</span></div>" +
      '<div class="cs-specs__row"><span>Thickness</span><span>' + esc(thickWords(c)) + "</span></div>" +
      '<div class="cs-specs__row"><span>Finish</span><span>' + esc(finishWords(c)) + "</span></div>" +
      '<div class="cs-specs__row"><span>Suitable for</span><span>Benchtop, splashback, waterfall ends</span></div>' +
      '<div class="cs-specs__row"><span>Warranty</span><span>Caesarstone lifetime</span></div>' +
      "</div></div>" +
      "</section></div>" +
      '<section class="cs-included"><div class="cs-wrap cs-included__inner"><h2>Every ' + esc(c.name) + " benchtop comes with</h2>" +
      '<div class="cs-included__grid">' +
      "<div><h3>Site template</h3><p>Measured on site once your cabinets are in. " + incAud(E.SITE_TEMPLATE_FEE_EX_GST) + ", in every estimate.</p></div>" +
      "<div><h3>Certified stonemason</h3><p>Made and installed through Caesarstone's certified fabricators.</p></div>" +
      "<div><h3>Installed in 2-3 weeks</h3><p>From check measure to benchtop in place.</p></div>" +
      "<div><h3>Lifetime warranty</h3><p>Caesarstone's lifetime warranty on the surface.</p></div></div>" +
      '<p class="cs-note">We install in NSW, ACT, VIC, QLD and SA. Every job is charged at a minimum of 3 m² of stone. <a href="' + TERMS_URL + '" target="_blank" rel="noopener">Stone benchtop terms</a></p></div></section>' +
      (related.length ? '<section class="cs-wrap cs-related"><div class="cs-related__head"><div><div class="cs-eyebrow">Same price, ' + priceFrom + incAud(fromRate(c)) + ' per m² incl. GST</div><h2 style="margin-top:10px">More in ' + esc(seriesOf(c)) + "</h2></div>" +
        '<a class="cs-btn cs-btn--ghost" href="' + esc(collectionUrl(c.range)) + '">Show all colours</a></div><div class="cs-grid">' + related.map(tileHtml).join("") + "</div></section>" : "");

    var main = root.querySelector("[data-cs-main]");
    var thumbs = root.querySelector("[data-cs-thumbs]");
    function edgeView() {
      var d = EDGE_DRAWINGS[edge] || EDGE_DRAWINGS.standard;
      return { label: "Edge detail", src: d.src, alt: "Caesarstone " + d.name + " edge profile", name: d.name, edge: true };
    }
    function renderGallery() {
      var v = views[view].edge ? edgeView() : views[view];
      main.classList.toggle("is-zoom", zoom && !v.edge);
      main.classList.toggle("is-slab", v.label === "Full slab");
      main.classList.toggle("is-edge", !!v.edge);
      main.innerHTML = '<img src="' + esc(v.edge ? v.src : sized(v.src, 1600)) + '" alt="' + esc(v.alt || "Caesarstone " + c.code + " " + c.name + ", " + v.label.toLowerCase()) + '"' + (v.edge ? ' width="189" height="86"' : "") + ">" +
        '<div class="cs-gallery__bar"><span class="cs-gallery__cap">' + (v.edge ? esc("Edge detail: " + v.name + ", Caesarstone's profile drawing.") : esc(v.label) + ". Colours on screen vary; order a free sample to see the real stone.") + "</span>" +
        (v.edge ? "" : '<button type="button" class="cs-icon-btn cs-zoom" data-cs-zoom aria-pressed="' + zoom + '" aria-label="' + (zoom ? "Zoom out" : "Zoom in") + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4M8 11h6' + (zoom ? "" : "M11 8v6") + '"/></svg></button>') + "</div>";
      thumbs.innerHTML = views.map(function (x, i) {
        if (x.edge) x = edgeView();
        return '<button type="button" class="cs-thumb' + (x.edge ? " cs-thumb--edge" : "") + '" data-cs-view="' + i + '" aria-pressed="' + (i === view) + '" aria-label="' + esc(x.label) + '">' +
          '<img src="' + esc(x.edge ? x.src : sized(x.src, 240)) + '" alt="">' + "</button>";
      }).join("");
    }
    var rateEl = root.querySelector("[data-cs-rate]");
    function render() {
      rateEl.textContent = incAud(c.ratesExGst[thickness]);
      var th = root.querySelector("[data-cs-thicks]");
      if (th) th.innerHTML = c.thicknesses.map(function (t) {
        return '<button type="button" class="cs-card-btn cs-card-btn--col" data-cs-thick="' + t + '" aria-pressed="' + (t === thickness) + '"><span class="cs-cb-name">' + t + ' mm</span><span class="cs-cb-sub">' + incAud(c.ratesExGst[t]) + " per m²</span></button>";
      }).join("");
      var avail = E.edgesAvailable(mat, thickness).map(function (e) { return e.id; });
      if (avail.indexOf(edge) < 0) edge = "standard";
      root.querySelector("[data-cs-edges]").innerHTML = E.edgesFor(mat).map(function (e) {
        var on = avail.indexOf(e.id) >= 0;
        return '<button type="button" class="cs-card-btn cs-card-btn--col" data-cs-edge="' + e.id + '" aria-pressed="' + (edge === e.id) + '"' + (on ? "" : " disabled") + ">" + edgeSvg(e.id === "chunky") +
          '<span class="cs-cb-name">' + esc(e.label) + '</span><span class="cs-cb-sub">' + (on ? incAud(e.pricePerMExGst) + " per metre" : "Needs the 20 mm slab") + "</span></button>";
      }).join("");
      var note = root.querySelector("[data-cs-edge-note]");
      var p12 = mat === "porcelain" && thickness === 12;
      note.textContent = p12 ? T.chunkyNeeds20 : "";
      note.classList.toggle("cs-hidden", !p12);
      var r = W.estimateWebsiteJob({ priceListId: c.priceListId, colourName: c.name, thicknessMm: thickness, edge: edge, sections: [{ name: "Section", lengthMm: L, depthMm: Dp, exposed: { front: true } }] });
      var qp = W.quickPriceLines(r);
      if (!qp) {
        root.querySelector("[data-cs-qlines]").innerHTML = "";
        root.querySelector("[data-cs-qtotal]").textContent = "";
        root.querySelector("[data-cs-qnote]").textContent = "Enter a length from " + W.RUN_LENGTH_MM[0] + " to " + W.RUN_LENGTH_MM[1] + " mm and a depth from " + W.RUN_DEPTH_MM[0] + " to " + W.RUN_DEPTH_MM[1] + " mm.";
        return;
      }
      root.querySelector("[data-cs-qlines]").innerHTML = qp.lines.map(function (l) { return '<div class="cs-line"><span>' + esc(l.label) + "</span><span>" + aud(l.incGst) + "</span></div>"; }).join("");
      root.querySelector("[data-cs-qtotal]").textContent = aud(qp.totalIncGst);
      root.querySelector("[data-cs-qnote]").textContent = (qp.minimumApplied ? "Under 3 m², so the 3 m² minimum applies. " : "") + "Stone is rounded up to the next 0.1 m². Estimate only; our team confirms the final price after a site template.";
    }
    root.addEventListener("click", function (ev) {
      var b = ev.target.closest("[data-cs-thick]");
      if (b) { thickness = +b.getAttribute("data-cs-thick"); render(); renderGallery(); return; }
      b = ev.target.closest("[data-cs-edge]");
      if (b && !b.disabled) { edge = b.getAttribute("data-cs-edge"); render(); renderGallery(); return; }
      b = ev.target.closest("[data-cs-view]");
      if (b) { view = +b.getAttribute("data-cs-view"); zoom = false; renderGallery(); return; }
      if (ev.target.closest("[data-cs-zoom]")) { zoom = !zoom; renderGallery(); }
    });
    root.querySelector("[data-cs-ql]").addEventListener("input", function (e) { L = +e.target.value; render(); });
    root.querySelector("[data-cs-qd]").addEventListener("input", function (e) { Dp = +e.target.value; render(); });
    renderGallery();
    render();
  }

  /* ── 3. configurator ─────────────────────────────────── */
  var KEY = "cs-benchtop-estimate-v1";
  function newSection(n) {
    return { name: n === 1 ? "Back run" : n === 2 ? "Island" : "Section " + n, lengthMm: n === 2 ? 2400 : 3000, depthMm: n === 2 ? 900 : 600,
      exposed: { front: true, back: n === 2, left: false, right: false }, waterfall: { left: false, right: false } };
  }
  /* PRICE PER SECTION: sections incl. GST, then the job lines in Mat's order, adding to the total to the cent */
  function pricedRows(r, sections) {
    var p = W.priceBySection(r);
    if (!p) return null;
    var secs = p.sections.map(function (s, i) {
      var sec = sections[i] || {};
      var bits = [Math.round(sec.lengthMm) + " × " + Math.round(sec.depthMm) + " mm", s.chargedSqm.toFixed(1) + " m²", E.roundEdgeM(s.edgeM).toFixed(2) + " m polished edge"];
      if (s.waterfallEnds) bits.push(s.waterfallEnds + " waterfall end" + (s.waterfallEnds > 1 ? "s" : "") + " (" + s.waterfallSqm.toFixed(1) + " m²)");
      if (s.splashbackSqm) bits.push("splashback " + s.splashbackSqm.toFixed(1) + " m²");
      return { label: s.label, detail: bits.join(", "), inc: s.incGst };
    });
    var rank = function (l) {
      if (l.kind === "cutout" || l.kind === "splashback-cutout") return 0;
      if (l.kind === "extra") return l.label === E.POLISH_UNDERSIDE.label ? 2 : 1;
      if (l.kind === "vein-matching") return 3;
      return 5;
    };
    var small = function (l) {
      if (l.kind === "template") return "";
      if (l.kind === "vein-matching") return l.qty + " join" + (l.qty === 1 ? "" : "s");
      if (l.kind === "extra" && l.unit === "m") return l.qty.toFixed(1) + " m";
      if (l.kind === "extra") return "once per job";
      return "× " + l.qty + (l.kind === "splashback-cutout" ? ", splashback" : "");
    };
    var job = p.job.map(function (l, i) { return { rank: rank(l), i: i, label: l.kind === "vein-matching" ? E.VEIN_MATCHING.label : m2(l.label), qty: small(l), inc: l.incGst }; });
    if (p.topUp) job.push({ rank: 4, i: 999, label: "3 m² minimum top-up", qty: p.topUp.measuredSqm.toFixed(1) + " m² measured, +" + p.topUp.sqm.toFixed(1) + " m²", inc: p.topUp.incGst });
    job.sort(function (a, b) { return a.rank - b.rank || a.i - b.i; });
    return { sections: secs, sectionsRaw: p.sections, job: job, gst: p.gst, total: p.totalIncGst };
  }
  /* top-down drawing of one section: polished edges solid, wall edges dashed, waterfall ends double */
  function planSvg(s) {
    var L = Math.max(100, +s.lengthMm || 0), Dp = Math.max(100, +s.depthMm || 0);
    var Wd = 220, H = 140, pad = 18;
    var k = Math.min((Wd - 2 * pad) / L, (H - 2 * pad) / Dp);
    var w = L * k, h = Dp * k, x = (Wd - w) / 2, y = (H - h) / 2;
    var ex = s.exposed || {}, wf = s.waterfall || {};
    function edge(x1, y1, x2, y2, kind, vertical) {
      if (kind === "waterfall") {
        var o = vertical ? [2.5, 0] : [0, 2.5];
        return '<path d="M' + (x1 - o[0]) + " " + (y1 - o[1]) + " L" + (x2 - o[0]) + " " + (y2 - o[1]) + " M" + (x1 + o[0]) + " " + (y1 + o[1]) + " L" + (x2 + o[0]) + " " + (y2 + o[1]) + '" stroke="#7D6942" stroke-width="2"/>';
      }
      if (kind === "polished") return '<path d="M' + x1 + " " + y1 + " L" + x2 + " " + y2 + '" stroke="#1a1a1a" stroke-width="3"/>';
      return '<path d="M' + x1 + " " + y1 + " L" + x2 + " " + y2 + '" stroke="#8a847a" stroke-width="1.2" stroke-dasharray="5 4"/>';
    }
    return '<svg viewBox="0 0 ' + Wd + " " + H + '" role="img" aria-label="Top-down plan of ' + esc(s.name) + '">' +
      '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="#e9e6e0"/>' +
      edge(x, y, x + w, y, ex.back ? "polished" : "wall") +
      edge(x, y + h, x + w, y + h, ex.front ? "polished" : "wall") +
      edge(x, y, x, y + h, wf.left ? "waterfall" : ex.left ? "polished" : "wall", true) +
      edge(x + w, y, x + w, y + h, wf.right ? "waterfall" : ex.right ? "polished" : "wall", true) +
      '<text x="' + Wd / 2 + '" y="' + Math.min(H - 3, y + h + 13) + '" text-anchor="middle" font-size="9" fill="#6e6a64" font-family="Montserrat, sans-serif">FRONT</text>' +
      '<text x="' + Wd / 2 + '" y="' + (y + h / 2 + 4) + '" text-anchor="middle" font-size="11" font-weight="600" fill="#1a1a1a" font-family="Montserrat, sans-serif">' + esc(L + " × " + Dp) + "</text></svg>";
  }
  function counterHtml(key, value, max, disabled, label) {
    return '<span class="cs-counter"><button type="button" class="cs-step-btn" data-cs-count="' + key + '" data-cs-d="-1" aria-label="Fewer ' + esc(label.toLowerCase()) + '"' + (disabled || value <= 0 ? " disabled" : "") + ">−</button>" +
      '<span class="cs-counter__v">' + value + "</span>" +
      '<button type="button" class="cs-step-btn" data-cs-count="' + key + '" data-cs-d="1" aria-label="More ' + esc(label.toLowerCase()) + '"' + (disabled || value >= max ? " disabled" : "") + ">+</button></span>";
  }

  /* ?job= carries a whole configuration (base64url JSON), from the "Reopen this configuration" link */
  function jobFromUrl() {
    var j = q("job");
    if (!j) return null;
    try {
      var b = j.replace(/-/g, "+").replace(/_/g, "/");
      while (b.length % 4) b += "=";
      var o = JSON.parse(decodeURIComponent(escape(atob(b))));
      return o && typeof o === "object" && BY_HANDLE[o.handle] && Array.isArray(o.sections) ? o : null;
    } catch (e) { return null; }
  }
  var QUOTE = window.CustomeaStoneQuote || {};
  var ENDPOINT = (QUOTE.endpoint || "https://customea-stone-quote.vercel.app").replace(/\/+$/, "");
  var FILE_TYPES = { pdf: "application/pdf", jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png", heic: "image/heic", heif: "image/heif" };
  var MAX_FILES = 5, MAX_FILE_BYTES = 10 * 1024 * 1024;
  function extOf(name) { var m = /\.([a-z0-9]+)$/i.exec(name || ""); return m ? m[1].toLowerCase() : ""; }
  function safeName(name) { return String(name || "file").normalize("NFKD").replace(/[^\w.\- ]+/g, "").replace(/\s+/g, "-").replace(/^-+|-+$/g, "").slice(-100) || "file"; }
  function sizeWords(n) { return n >= 1048576 ? (n / 1048576).toFixed(1) + " MB" : Math.max(1, Math.round(n / 1024)) + " KB"; }
  function newQuoteId() { var a = new Uint8Array(16); (window.crypto || {}).getRandomValues ? crypto.getRandomValues(a) : a.forEach(function (_, i) { a[i] = Math.random() * 256; }); return Array.prototype.map.call(a, function (x) { return ("0" + (x % 36).toString(36)).slice(-1); }).join("") + Date.now().toString(36); }
  function loadUploadLib() {
    return new Promise(function (resolve, reject) {
      if (window.CustomeaBlobUpload) return resolve(window.CustomeaBlobUpload);
      if (!QUOTE.uploadJs) return reject(new Error("upload library missing"));
      var s = document.createElement("script");
      s.src = QUOTE.uploadJs;
      s.onload = function () { window.CustomeaBlobUpload ? resolve(window.CustomeaBlobUpload) : reject(new Error("upload library missing")); };
      s.onerror = function () { reject(new Error("upload library missing")); };
      document.head.appendChild(s);
    });
  }

  function initConfigurator(root) {
    var fromLink = jobFromUrl();
    var saved = fromLink || store(KEY) || {};
    var st = {
      handle: BY_HANDLE[saved.handle] ? saved.handle : "1141-pure-white",
      thickness: saved.thickness, edge: saved.edge || "standard",
      sections: Array.isArray(saved.sections) && saved.sections.length ? saved.sections : [newSection(1)],
      benchHeightMm: saved.benchHeightMm || W.DEFAULT_BENCH_HEIGHT_MM,
      sink: saved.sink || "none", sinks: saved.sinks == null ? 1 : saved.sinks,
      cooktops: saved.cooktops == null ? 1 : saved.cooktops, taps: saved.taps == null ? 1 : saved.taps, gpo: saved.gpo != null ? saved.gpo : saved.gpos || 0,
      extras: Array.isArray(saved.extras) ? saved.extras : [], polishUndersideM: saved.polishUndersideM || 0,
      splashback: !!saved.splashback, splashbackGpo: saved.splashbackGpo || 0,
      veinMatching: !!saved.veinMatching, veinJoins: Number.isFinite(saved.veinJoins) && saved.veinJoins > 0 ? saved.veinJoins : undefined,
      pickRange: null, search: "",
    };
    if (!fromLink && q("colour") && BY_HANDLE[q("colour")]) { st.handle = q("colour"); st.thickness = undefined; }
    var form = root.querySelector("[data-cs-form]");
    var aside = root.querySelector("[data-cs-aside]");
    var last = null;
    root.querySelectorAll("[data-cs-planner]").forEach(function (a) { a.setAttribute("href", PLANNER_URL); });

    function colour() { return BY_HANDLE[st.handle]; }
    function mat() { return material(colour()); }
    function job() {
      var c = colour();
      return { priceListId: c.priceListId, colourName: c.name, thicknessMm: st.thickness, edge: st.edge, benchHeightMm: st.benchHeightMm,
        sections: st.sections, sink: st.sink, sinks: st.sinks, cooktops: st.cooktops, taps: st.taps, gpo: st.gpo,
        extras: st.extras, polishUndersideM: st.polishUndersideM, splashback: st.splashback, splashbackGpo: st.splashbackGpo,
        veinMatching: st.veinMatching, veinJoins: st.veinJoins };
    }
    function lines(kind) { return last ? last.estimate.lines.filter(function (l) { return l.kind === kind; }) : []; }
    function sumEx(kinds) { return kinds.reduce(function (t, k) { return t + lines(k).reduce(function (s, l) { return s + l.amountExGst; }, 0); }, 0); }
    function el(sel) { return root.querySelector(sel); }
    function setAmt(sel, ex) { var x = el(sel); if (x) x.textContent = ex > 0 ? incAud(ex) : ""; }

    /* 01 colour + 03 edge */
    function renderColour() {
      var c = colour();
      if (c.thicknesses.indexOf(+st.thickness) < 0) st.thickness = c.thicknesses[0];
      var range = st.pickRange || c.range;
      el("[data-cs-selected]").innerHTML = '<img src="' + esc(sized(cardImage(c), 300)) + '" alt="Caesarstone ' + esc(c.code + " " + c.name) + '" width="112" height="112">' +
        '<div class="cs-selected__copy"><span class="cs-label">Selected · Caesarstone ' + esc(seriesOf(c)) + '</span><span class="cs-selected__name">' + esc(c.name) + '</span><span class="cs-selected__meta">' + esc(c.code + " · " + finishWords(c) + " · " + incAud(c.ratesExGst[+st.thickness]) + " per m² incl. GST") + "</span></div>" +
        '<a class="cs-linkbtn" href="' + esc(colourUrl(c)) + '">View colour page</a>';
      el("[data-cs-pickrange]").innerHTML = ["Mineral", "Porcelain"].map(function (r) {
        return '<button type="button" data-cs-pickrange="' + r + '" aria-pressed="' + (!st.search.trim() && r === range) + '">' + r + " · " + COLOURS.filter(function (x) { return x.range === r; }).length + "</button>";
      }).join("");
      var needle = st.search.trim().toLowerCase();
      var list = COLOURS.filter(function (x) { return needle ? (x.name + " " + x.code).toLowerCase().indexOf(needle) >= 0 : x.range === range; });
      el("[data-cs-swatches]").innerHTML = list.length ? list.map(function (x) {
        return '<button type="button" class="cs-swatch" data-cs-pick="' + esc(x.handle) + '" aria-pressed="' + (x.handle === c.handle) + '" aria-label="' + esc(x.name + ", " + x.code + ", " + seriesOf(x)) + '">' +
          '<span class="cs-swatch__img"><img loading="lazy" src="' + esc(sized(cardImage(x), 200)) + '" alt="" width="200" height="200"></span><span class="cs-swatch__n">' + esc(x.name) + '</span><span class="cs-swatch__c">' + esc(x.code) + "</span></button>";
      }).join("") : '<p class="cs-note">No colour matches "' + esc(st.search) + '".</p>';
      var thWrap = el("[data-cs-thick-wrap]");
      thWrap.classList.toggle("cs-hidden", c.thicknesses.length < 2);
      el("[data-cs-thicks]").innerHTML = c.thicknesses.map(function (t) {
        return '<button type="button" class="cs-card-btn" data-cs-thick="' + t + '" aria-pressed="' + (t === +st.thickness) + '"><span class="cs-cb-name">' + t + ' mm</span><span class="cs-cb-price">' + incAud(c.ratesExGst[t]) + " per m²</span></button>";
      }).join("");
      var m = mat();
      var avail = E.edgesAvailable(m, +st.thickness).map(function (e) { return e.id; });
      var resolved = E.resolveEdge(m, +st.thickness, st.edge);
      el("[data-cs-edges]").innerHTML = E.edgesFor(m).map(function (e) {
        var on = avail.indexOf(e.id) >= 0;
        return '<button type="button" class="cs-card-btn" data-cs-edge="' + e.id + '" aria-pressed="' + (resolved.edge === e.id) + '"' + (on ? "" : " disabled") + ">" + edgeSvg(e.id === "chunky", 80) +
          '<span style="display:flex;flex-direction:column;gap:4px;min-width:0"><span class="cs-cb-name">' + esc(e.label) + '</span><span class="cs-cb-sub">' + (on ? incAud(e.pricePerMExGst) + " per metre incl. GST" : "Needs the 20 mm slab") + "</span></span></button>";
      }).join("");
      var note = el("[data-cs-edge-note]");
      var p12 = m === "porcelain" && +st.thickness === 12;
      note.textContent = p12 ? (resolved.fellBack ? "This design asked for the 40 mm Double Mitred edge, which needs 20 mm porcelain. Pencil Round is shown instead." : T.chunkyNeeds20) : "";
      note.classList.toggle("cs-hidden", !p12);
    }
    /* 02 sections */
    function renderSections() {
      el("[data-cs-sections]").innerHTML = st.sections.map(function (s, i) {
        var ex = s.exposed || {}, wf = s.waterfall || {};
        function pill(group, key, label, disabled) {
          var on = group === "w" ? !!wf[key] : !!ex[key];
          return '<button type="button" class="cs-pill" data-cs-s="' + i + '" data-cs-g="' + group + '" data-cs-k="' + key + '" aria-pressed="' + on + '"' + (disabled ? " disabled" : "") + ">" + label + "</button>";
        }
        return '<div class="cs-section" data-cs-section="' + i + '"><div class="cs-section__fields">' +
          '<div class="cs-section__top"><label class="cs-sr" for="cs-sn-' + i + '">Section name</label><input id="cs-sn-' + i + '" class="cs-section__name" type="text" maxlength="40" value="' + esc(s.name) + '" data-cs-s="' + i + '" data-cs-f="name">' +
          '<span class="cs-section__price"><span data-cs-section-price="' + i + '"></span>' +
          (st.sections.length > 1 ? '<button type="button" class="cs-icon-btn" data-cs-remove="' + i + '" aria-label="Remove ' + esc(s.name) + '">×</button>' : "") + "</span></div>" +
          '<div class="cs-section__dims"><label class="cs-field">Length, mm<input class="cs-input" type="number" inputmode="numeric" min="' + W.RUN_LENGTH_MM[0] + '" max="' + W.RUN_LENGTH_MM[1] + '" step="10" value="' + esc(s.lengthMm) + '" data-cs-s="' + i + '" data-cs-f="lengthMm"></label>' +
          '<label class="cs-field">Depth, mm<input class="cs-input" type="number" inputmode="numeric" min="' + W.RUN_DEPTH_MM[0] + '" max="' + W.RUN_DEPTH_MM[1] + '" step="10" value="' + esc(s.depthMm) + '" data-cs-s="' + i + '" data-cs-f="depthMm"></label></div>' +
          '<div class="cs-section__groups"><div class="cs-section__group"><span class="cs-label">Polished edges</span><div>' +
          pill("e", "front", "Front") + pill("e", "back", "Back") + pill("e", "left", "Left end", wf.left) + pill("e", "right", "Right end", wf.right) + "</div></div>" +
          '<div class="cs-section__group"><span class="cs-label">Waterfall end</span><div>' + pill("w", "left", "Left") + pill("w", "right", "Right") + "</div></div></div>" +
          '<div class="cs-section__detail" data-cs-section-detail="' + i + '"></div></div>' +
          '<div class="cs-plan" data-cs-plan="' + i + '">' + planSvg(s) + "</div></div>";
      }).join("");
    }
    /* 04 splashback */
    function renderSplash() {
      var m = mat();
      var wallIdx = [];
      st.sections.forEach(function (s, i) { if (W.meetsWall(s)) wallIdx.push(i); });
      var hasWall = wallIdx.length > 0;
      var on = st.splashback && hasWall;
      setAmt("[data-cs-splash-amt]", on ? sumEx(["splashback", "splashback-edge", "splashback-cutout"]) : 0);
      var h = '<button type="button" class="cs-card-btn" role="switch" data-cs-splash-toggle aria-checked="' + on + '"' + (hasWall ? "" : " disabled") + '><span class="cs-tick" aria-hidden="true">' + (on ? "✓" : "") + "</span>" +
        '<span style="display:flex;flex-direction:column;gap:4px;min-width:0"><span class="cs-cb-name">' + esc(T.splashbackToggle) + '</span><span class="cs-cb-sub">' +
        esc(hasWall ? WW.splashbackDesc + " " + E.MATERIAL_LABEL[m] + " splashback is " + W.splashbackThicknessMm(m) + " mm." : WW.noWall) + "</span></span></button>";
      if (on && last) {
        var areas = {};
        last.estimate.areas.forEach(function (a) { areas[a.id] = a; });
        h += '<div class="cs-sbrows">' + wallIdx.map(function (i) {
          var s = st.sections[i], sb = W.splashbackFor(s), id = "s" + (i + 1) + "-splashback";
          var edgeM = ((sb.top ? sb.lengthMm : 0) + (sb.left ? sb.heightMm : 0) + (sb.right ? sb.heightMm : 0)) / 1000;
          function pill(k, label) { return '<button type="button" class="cs-pill" data-cs-sb="' + i + '" data-cs-sbk="' + k + '" aria-pressed="' + !!sb[k] + '">' + label + "</button>"; }
          return '<div class="cs-sbrow' + (sb.off ? " is-off" : "") + '"><div class="cs-sbrow__head"><span>' + esc(s.name) + ' splashback</span><button type="button" class="cs-mini" data-cs-sb-off="' + i + '">' + (sb.off ? "Restore" : "Remove") + "</button></div>" +
            (sb.off ? '<p class="cs-fine">No splashback on this section: nothing priced. Restore it to bring it back as it was.</p>' :
              '<div class="cs-two"><label class="cs-field">Height, mm<input class="cs-input" type="number" inputmode="numeric" min="' + W.SPLASHBACK_HEIGHT_MM[0] + '" max="' + W.SPLASHBACK_HEIGHT_MM[1] + '" step="10" value="' + sb.heightMm + '" data-cs-sbv="' + i + '" data-cs-sbk="heightMm"></label>' +
              '<label class="cs-field">Length, mm<input class="cs-input" type="number" inputmode="numeric" min="' + W.SPLASHBACK_MIN_LENGTH_MM + '" max="' + esc(s.lengthMm) + '" step="10" value="' + sb.lengthMm + '" data-cs-sbv="' + i + '" data-cs-sbk="lengthMm"></label></div>' +
              '<div><span class="cs-label">Exposed edges, polished</span><div style="display:flex;flex-wrap:wrap;gap:6px;margin-top:6px">' + pill("top", "Top") + pill("left", "Left end") + pill("right", "Right end") + "</div></div>" +
              '<span class="cs-fine">' + (areas[id] ? areas[id].measuredSqm.toFixed(2) : "0.00") + " m², " + edgeM.toFixed(2) + " m of exposed edge</span>") + "</div>";
        }).join("") + "</div>";
        var note = W.splashbackEdgeNote(last.estimate);
        h += '<div class="cs-sbfoot"><p class="cs-fine">' + (note ? esc(note) + " " : "") + esc(T.splashbackEdgeNote) + "</p>" +
          '<div class="cs-countrow"><span>' + esc(T.splashbackGpo) + ", " + incAud(E.cutoutPrice("gpo", m).priceEachExGst) + " " + esc(T.splashbackGpoNote) + "</span>" + counterHtml("splashbackGpo", st.splashbackGpo, MAX, false, T.splashbackGpo) + "</div></div>";
      }
      el("[data-cs-splash]").innerHTML = h;
    }
    /* 05 sinks + cutouts */
    function renderCutouts() {
      var m = mat();
      var ids = E.sinkCutoutIdsFor(m);
      if (st.sink !== "none" && ids.indexOf(st.sink) < 0) st.sink = "none";
      setAmt("[data-cs-cut-amt]", sumEx(["cutout"]));
      el("[data-cs-sinks]").innerHTML = '<button type="button" class="cs-card-btn cs-card-btn--col" data-cs-sink="none" aria-pressed="' + (st.sink === "none") + '"><span class="cs-cb-name">' + esc(T.noSink) + '</span><span class="cs-cb-sub">$0.00</span></button>' +
        ids.map(function (id) {
          var p = E.cutoutPrice(id, m);
          return '<button type="button" class="cs-card-btn cs-card-btn--col" data-cs-sink="' + id + '" aria-pressed="' + (st.sink === id) + '"><span class="cs-cb-name">' + esc(p.label) + '</span><span class="cs-cb-sub">' + incAud(p.priceEachExGst) + " each</span></button>";
        }).join("");
      var each = function (id) { return incAud(E.cutoutPrice(id, m).priceEachExGst) + " each"; };
      var rows = [
        ["sinks", T.sinks, st.sink === "none" ? "Choose a sink above" : "of the sink above", st.sink === "none" ? 0 : st.sinks, st.sink === "none"],
        ["cooktops", T.cooktops, each("cooktop"), st.cooktops, false],
        ["taps", T.taps, each("tap"), st.taps, false],
        ["gpo", T.gpo, each("gpo"), st.gpo, false],
      ];
      el("[data-cs-counts]").innerHTML = rows.map(function (r) {
        return '<div class="cs-countcard' + (r[4] ? " is-off" : "") + '"><span class="cs-countcard__t"><b>' + esc(r[1]) + "</b><span>" + esc(r[2]) + "</span></span>" + counterHtml(r[0], r[3], MAX, r[4], r[1]) + "</div>";
      }).join("");
    }
    /* 06 extras + underside polish */
    function renderExtras() {
      var m = mat();
      var P = E.POLISH_UNDERSIDE;
      var pm = st.polishUndersideM || 0;
      setAmt("[data-cs-extras-amt]", sumEx(["extra"]));
      el("[data-cs-extras]").innerHTML = E.EXTRAS.map(function (x) {
        var on = st.extras.indexOf(x.id) >= 0;
        return '<button type="button" class="cs-card-btn" role="switch" data-cs-extra="' + x.id + '" aria-checked="' + on + '"><span class="cs-tick" aria-hidden="true">' + (on ? "✓" : "") + "</span>" +
          '<span style="display:flex;flex-direction:column;gap:4px;flex:1 1 auto;min-width:0"><span class="cs-cb-name">' + esc(x.label) + '</span><span class="cs-cb-sub">' + esc(x.note || "") + '</span></span><span class="cs-cb-price">' + incAud(x.priceExGst[m]) + "</span></button>";
      }).join("");
      el("[data-cs-polish]").innerHTML = '<span class="cs-polish__t"><b>' + esc(P.label) + "</b><span>" + esc(P.note) + " " + incAud(P.pricePerMExGst[m]) + " " + esc(T.perMetre) + " incl. GST.</span></span>" +
        '<span class="cs-polish__ctl"><span class="cs-counter"><button type="button" class="cs-step-btn" data-cs-polish-step="-1" aria-label="Less overhang edge"' + (pm <= 0 ? " disabled" : "") + ">−</button>" +
        '<label class="cs-sr" for="cs-polish-m">Metres of overhang edge to polish</label><input id="cs-polish-m" class="cs-counter__v" type="number" inputmode="decimal" min="0" max="' + P.maxM + '" step="' + P.stepM + '" value="' + pm + '" data-cs-polish-m>' +
        '<button type="button" class="cs-step-btn" data-cs-polish-step="1" aria-label="More overhang edge"' + (pm >= P.maxM ? " disabled" : "") + '>+</button></span><span class="cs-polish__amt">' + (pm > 0 ? incAud(P.pricePerMExGst[m] * pm) : "") + "</span></span>";
    }
    /* 07 vein matching: the count shown is the count charged */
    function renderVein() {
      var m = mat();
      var vs = W.veinState(st.sections, st.veinMatching, st.veinJoins);
      var perJoin = E.VEIN_MATCHING.pricePerJoinExGst[m];
      setAmt("[data-cs-vein-amt]", sumEx(["vein-matching"]));
      var after = function (d) { return W.veinState(st.sections, true, W.veinStep(st.sections, st.veinJoins, d)).charged; };
      el("[data-cs-vein]").innerHTML =
        '<button type="button" class="cs-card-btn" role="switch" data-cs-vein-toggle aria-checked="' + st.veinMatching + '"><span class="cs-tick" aria-hidden="true">' + (st.veinMatching ? "✓" : "") + "</span>" +
        '<span style="display:flex;flex-direction:column;gap:4px;min-width:0"><span class="cs-cb-name">' + esc(T.veinToggle) + '</span><span class="cs-cb-sub">' + incAud(perJoin) + " " + esc(T.perJoin) + " " + esc(WW.veinCount) +
        (vs.own > 0 ? " Your sections run past one slab length, so " + vs.own + " join" + (vs.own === 1 ? " is" : "s are") + " counted already." : "") + "</span></span></button>" +
        (st.veinMatching ? '<div class="cs-countrow"><span>' + esc(T.veinJoins) + ", " + incAud(perJoin) + " each</span><span class=\"cs-counter\">" +
          '<button type="button" class="cs-step-btn" data-cs-vein="-1" aria-label="Fewer joins"' + (after(-1) === vs.charged ? " disabled" : "") + ">−</button>" +
          '<span class="cs-counter__v" data-cs-vein-count>' + vs.charged + "</span>" +
          '<button type="button" class="cs-step-btn" data-cs-vein="1" aria-label="More joins"' + (after(1) === vs.charged ? " disabled" : "") + ">+</button></span></div>" +
          (vs.charged === 0 ? '<p class="cs-fine">No joins yet, so nothing is charged. Add one for each corner where two benchtops meet.</p>' : "") : "");
    }
    function renderRail() {
      var vs = W.veinState(st.sections, st.veinMatching, st.veinJoins);
      var done = {
        s1: true, s2: st.sections.length > 0, s3: true, s4: st.splashback,
        s5: st.sink !== "none" || st.cooktops > 0 || st.taps > 0 || st.gpo > 0, s6: st.extras.length > 0 || st.polishUndersideM > 0,
        s7: st.veinMatching && vs.charged > 0, s8: !!root.querySelector("[data-cs-status].cs-ok"),
      };
      root.querySelectorAll("[data-cs-rail] a").forEach(function (a) {
        var k = a.getAttribute("href").slice(1);
        a.classList.toggle("is-done", !!done[k]);
      });
    }
    function renderSummary() {
      var r;
      try { r = W.estimateWebsiteJob(job()); } catch (e) { last = null; aside.innerHTML = '<div class="cs-sum"><div class="cs-sum__body"><p class="cs-err">' + esc(e.message) + "</p></div></div>"; return; }
      last = r;
      var c = colour(), est = r.estimate;
      var pr = pricedRows(r, st.sections);
      st.sections.forEach(function (s, i) {
        var priceEl = root.querySelector('[data-cs-section-price="' + i + '"]');
        if (priceEl) priceEl.textContent = pr && pr.sections[i] ? aud(pr.sections[i].inc) : "";
        var det = root.querySelector('[data-cs-section-detail="' + i + '"]');
        if (det) {
          var sr = pr && pr.sectionsRaw[i];
          det.textContent = sr ? sr.chargedSqm.toFixed(1) + " m² stone · " + E.roundEdgeM(sr.edgeM).toFixed(2) + " m polished edge" + (sr.waterfallEnds ? " · " + sr.waterfallEnds + " waterfall end" + (sr.waterfallEnds > 1 ? "s" : "") + " (" + sr.waterfallSqm.toFixed(1) + " m²)" : "") : "";
        }
      });
      setAmt("[data-cs-sections-amt]", 0);
      var secAmt = el("[data-cs-sections-amt]");
      if (secAmt && pr) secAmt.textContent = aud(pr.sections.reduce(function (t, s) { return t + Math.round(s.inc * 100); }, 0) / 100);
      var flags = r.sinkRefused ? '<p class="cs-flag">That sink cutout is not on the ' + esc(seriesOf(c)) + " list, so it is left out.</p>" : "";
      aside.innerHTML = '<div class="cs-sum" id="cs-summary">' +
        '<div class="cs-sum__top"><span class="cs-label">Your estimate, incl. GST</span><span class="cs-sum__fig" data-cs-total aria-live="polite">' + esc(aud(est.totalIncGst)) + '</span><span class="cs-sum__colour">Caesarstone ' + esc(c.code + " " + c.name) + ", " + esc(seriesOf(c)) + " " + r.thicknessMm + " mm, " + esc(E.edgeOption(r.edge, material(c)).label) + " edge</span></div>" +
        '<div class="cs-sum__body">' +
        (est.nothingToPrice || !pr ? '<p class="cs-flag">' + esc(m2(est.notes[0] || "")) + "</p>" :
          '<span class="cs-sum__h">Sections</span>' + pr.sections.map(function (s) { return '<div class="cs-sum__row"><span><b>' + esc(s.label) + "</b><small>" + esc(s.detail) + "</small></span><span>" + esc(aud(s.inc)) + "</span></div>"; }).join("") +
          '<span class="cs-sum__h">Whole job</span>' + pr.job.map(function (l) { return '<div class="cs-sum__row"><span>' + esc(l.label) + (l.qty ? ' <span class="cs-q">' + esc(l.qty) + "</span>" : "") + "</span><span>" + esc(aud(l.inc)) + "</span></div>"; }).join("") +
          '<div class="cs-sum__gst"><span>Includes GST</span><span>' + esc(aud(pr.gst)) + "</span></div>" +
          '<div class="cs-sum__total"><span>Estimate</span><span>' + esc(aud(pr.total)) + "</span></div>" +
          '<p class="cs-fine">The price of each section is its stone (rounded up to 0.1 m² per run), polished edges, waterfall ends and splashback. Every price here includes GST.</p>') +
        flags + "</div>" +
        '<div class="cs-sum__foot"><a class="cs-btn cs-btn--block" href="#s8">Request your quote</a>' +
        '<button type="button" class="cs-btn cs-btn--ghost cs-btn--block" data-cs-pdf' + (est.nothingToPrice ? " disabled" : "") + ">Download estimate PDF</button>" +
        '<p class="cs-fine">' + esc(DISCLAIMER) + " 3 m² minimum per job. Prices from Caesarstone's list dated " + esc(D.priceListDate.split("-").reverse().join("/")) + ".</p></div></div>";
      var mb = root.querySelector("[data-cs-mbar-fig]");
      if (mb) mb.textContent = aud(est.totalIncGst);
      store(KEY, { handle: st.handle, thickness: st.thickness, edge: st.edge, sections: st.sections, benchHeightMm: st.benchHeightMm, sink: st.sink, sinks: st.sinks,
        cooktops: st.cooktops, taps: st.taps, gpo: st.gpo, extras: st.extras, polishUndersideM: st.polishUndersideM, splashback: st.splashback,
        splashbackGpo: st.splashbackGpo, veinMatching: st.veinMatching, veinJoins: st.veinJoins });
    }
    function renderHeight() {
      var anyWf = st.sections.some(function (s) { return s.waterfall && (s.waterfall.left || s.waterfall.right); });
      el("[data-cs-height-wrap]").classList.toggle("cs-hidden", !anyWf);
    }
    /* summary first: the option rows read their charge off the estimate */
    function priced() { renderSummary(); renderHeight(); renderSplash(); renderCutouts(); renderExtras(); renderVein(); renderRail(); }
    function all() { renderColour(); renderSections(); priced(); }

    form.addEventListener("click", function (ev) {
      var b;
      if ((b = ev.target.closest("[data-cs-pickrange]"))) { st.pickRange = b.getAttribute("data-cs-pickrange"); st.search = ""; el("[data-cs-search]").value = ""; renderColour(); return; }
      if ((b = ev.target.closest("[data-cs-pick]"))) { st.handle = b.getAttribute("data-cs-pick"); st.thickness = undefined; all(); return; }
      if ((b = ev.target.closest("[data-cs-thick]"))) { st.thickness = +b.getAttribute("data-cs-thick"); renderColour(); priced(); return; }
      if ((b = ev.target.closest("[data-cs-edge]"))) { if (!b.disabled) { st.edge = b.getAttribute("data-cs-edge"); renderColour(); priced(); } return; }
      if ((b = ev.target.closest("[data-cs-remove]"))) { st.sections.splice(+b.getAttribute("data-cs-remove"), 1); renderSections(); priced(); return; }
      if (ev.target.closest("[data-cs-add]")) { st.sections.push(newSection(st.sections.length + 1)); renderSections(); priced(); return; }
      if ((b = ev.target.closest("[data-cs-g]"))) {
        if (b.disabled) return;
        var sec = st.sections[+b.getAttribute("data-cs-s")];
        var g = b.getAttribute("data-cs-g") === "w" ? "waterfall" : "exposed";
        sec[g] = sec[g] || {};
        sec[g][b.getAttribute("data-cs-k")] = !sec[g][b.getAttribute("data-cs-k")];
        renderSections(); priced(); return;
      }
      if (ev.target.closest("[data-cs-splash-toggle]")) { st.splashback = !st.splashback; if (!st.splashback) st.splashbackGpo = 0; priced(); return; }
      if ((b = ev.target.closest("[data-cs-sb-off]"))) { var s1 = st.sections[+b.getAttribute("data-cs-sb-off")]; s1.splashback = s1.splashback || {}; s1.splashback.off = !s1.splashback.off; priced(); return; }
      if ((b = ev.target.closest("[data-cs-sb]"))) { var s2 = st.sections[+b.getAttribute("data-cs-sb")], k2 = b.getAttribute("data-cs-sbk"); s2.splashback = s2.splashback || {}; s2.splashback[k2] = !W.splashbackFor(s2)[k2]; priced(); return; }
      if ((b = ev.target.closest("[data-cs-sink]"))) { st.sink = b.getAttribute("data-cs-sink"); if (st.sink !== "none" && !st.sinks) st.sinks = 1; priced(); return; }
      if ((b = ev.target.closest("[data-cs-count]"))) { if (b.disabled) return; var k = b.getAttribute("data-cs-count"); st[k] = Math.max(0, Math.min(MAX, (+st[k] || 0) + +b.getAttribute("data-cs-d"))); priced(); return; }
      if ((b = ev.target.closest("[data-cs-extra]"))) { var id = b.getAttribute("data-cs-extra"); var i = st.extras.indexOf(id); if (i >= 0) st.extras.splice(i, 1); else st.extras.push(id); st.extras.sort(); priced(); return; }
      if ((b = ev.target.closest("[data-cs-polish-step]"))) { if (b.disabled) return; var P = E.POLISH_UNDERSIDE; st.polishUndersideM = Math.min(P.maxM, Math.max(0, Math.round(((st.polishUndersideM || 0) + P.stepM * +b.getAttribute("data-cs-polish-step")) * 10) / 10)); priced(); return; }
      if (ev.target.closest("[data-cs-vein-toggle]")) { st.veinMatching = !st.veinMatching; st.veinJoins = undefined; priced(); return; }
      if ((b = ev.target.closest("[data-cs-vein]"))) { if (b.disabled) return; st.veinJoins = W.veinStep(st.sections, st.veinJoins, +b.getAttribute("data-cs-vein")); priced(); }
    });
    form.addEventListener("change", function (ev) {
      var t = ev.target;
      if (t.hasAttribute("data-cs-polish-m")) { var v = Number(t.value); st.polishUndersideM = Number.isFinite(v) ? Math.min(E.POLISH_UNDERSIDE.maxM, Math.max(0, Math.round(v * 10) / 10)) : 0; priced(); return; }
      if (t.hasAttribute("data-cs-sbv")) { var s = st.sections[+t.getAttribute("data-cs-sbv")]; s.splashback = s.splashback || {}; s.splashback[t.getAttribute("data-cs-sbk")] = t.value === "" ? undefined : +t.value; priced(); }
    });
    form.addEventListener("input", function (ev) {
      var t = ev.target;
      if (t.hasAttribute("data-cs-search")) { st.search = t.value; renderColour(); return; }
      if (t.hasAttribute("data-cs-f")) {
        var s = st.sections[+t.getAttribute("data-cs-s")], f = t.getAttribute("data-cs-f");
        s[f] = f === "name" ? t.value : t.value === "" ? "" : +t.value;
        var plan = root.querySelector('[data-cs-plan="' + t.getAttribute("data-cs-s") + '"]');
        if (plan) plan.innerHTML = planSvg(s);
        priced(); return;
      }
      if (t.hasAttribute("data-cs-job")) { st[t.getAttribute("data-cs-job")] = Math.max(0, +t.value || 0); priced(); }
    });
    el('[data-cs-job="benchHeightMm"]').value = st.benchHeightMm;

    /* 08: the quote request. Our own form, posted to the customea-stone-quote endpoint, which re-prices the
       job on the server, keeps the files for 90 days and emails info@ and the customer. No Shopify contact
       form, so no Shopify CAPTCHA (the v6 email arrived with Colour, Estimate, Price list date and Body empty
       because Shopify's captcha script submitted the form even when this script's checks had stopped it). */
    var qform = root.querySelector("[data-cs-quote]");
    var files = [];
    var sending = false;
    function stateForQuote() {
      return { handle: st.handle, thickness: st.thickness, edge: st.edge, sections: st.sections, benchHeightMm: st.benchHeightMm, sink: st.sink, sinks: st.sinks,
        cooktops: st.cooktops, taps: st.taps, gpo: st.gpo, extras: st.extras, polishUndersideM: st.polishUndersideM, splashback: st.splashback,
        splashbackGpo: st.splashbackGpo, veinMatching: st.veinMatching, veinJoins: st.veinJoins };
    }
    function contactOf() {
      var v = function (n) { var e = qform.querySelector('[name="' + n + '"]'); return e ? e.value.trim() : ""; };
      return { name: v("name"), email: v("email"), phone: v("phone"), street: v("street"), suburb: v("suburb"), state: v("state"), postcode: v("postcode"), message: v("message"), website: v("website") };
    }
    function contactErrors(ct) {
      var e = {};
      if (ct.name.length < 2) e.name = T.errName;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(ct.email)) e.email = T.errEmail;
      if (ct.phone.replace(/[^\d+]/g, "").length < 8) e.phone = T.errPhone;
      if (ct.street.length < 3) e.street = T.errStreet;
      if (ct.suburb.length < 2) e.suburb = T.errSuburb;
      if (!ct.state) e.state = T.errState;
      if (!/^\d{4}$/.test(ct.postcode)) e.postcode = T.errPostcode;
      return e;
    }
    function showErrors(errs) {
      qform.querySelectorAll("[data-cs-err]").forEach(function (p) { var k = p.getAttribute("data-cs-err"); p.textContent = errs[k] || ""; p.classList.toggle("cs-hidden", !errs[k]); });
      var first = Object.keys(errs).filter(function (k) { return k !== "files"; })[0];
      var input = first && qform.querySelector('[name="' + first + '"]');
      if (input) input.focus();
    }
    function status(kind, html) {
      var box = qform.querySelector("[data-cs-status]");
      box.className = kind ? (kind === "ok" ? "cs-ok" : kind === "err" ? "cs-err" : "cs-flag") : "";
      box.innerHTML = html || "";
      if (kind) box.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
    function fileProblem(f) {
      var ext = extOf(f.name);
      if (!FILE_TYPES[ext]) return f.name + ": only PDF, JPG, PNG or HEIC files can be attached.";
      if (!(f.size > 0)) return f.name + ": the file is empty.";
      if (f.size > MAX_FILE_BYTES) return f.name + ": files must be 10 MB or smaller (this one is " + sizeWords(f.size) + ").";
      return null;
    }
    function renderFiles(note) {
      qform.querySelector("[data-cs-filelist]").innerHTML = files.map(function (f, i) {
        return '<li class="cs-file"><span class="cs-file__name">' + esc(f.name) + '</span><span class="cs-file__size">' + sizeWords(f.size) + '</span><button type="button" class="cs-mini" data-cs-file-remove="' + i + '" aria-label="Remove ' + esc(f.name) + '">Remove</button></li>';
      }).join("");
      var err = qform.querySelector('[data-cs-err="files"]');
      err.textContent = note || "";
      err.classList.toggle("cs-hidden", !note);
      qform.querySelector("[data-cs-files-pick]").classList.toggle("cs-hidden", files.length >= MAX_FILES);
    }
    function pdfBlob() {
      return new Promise(function (resolve, reject) {
        loadJsPdf(function (ok) {
          if (!ok) return reject(new Error("pdf"));
          loadPdfFonts(function () { try { resolve(buildPdf(last, contactOf(), colour(), st.sections).output("blob")); } catch (e) { reject(e); } });
        });
      });
    }
    if (qform) {
      qform.querySelector("[data-cs-files]").addEventListener("change", function (ev) {
        var bad = [];
        Array.prototype.forEach.call(ev.target.files || [], function (f) {
          var p = fileProblem(f);
          if (p) bad.push(p);
          else if (files.length >= MAX_FILES) bad.push(f.name + ": you can attach up to " + MAX_FILES + " files.");
          else files.push(f);
        });
        ev.target.value = "";
        renderFiles(bad.join(" "));
      });
      qform.addEventListener("click", function (ev) {
        var b = ev.target.closest("[data-cs-file-remove]");
        if (b) { files.splice(+b.getAttribute("data-cs-file-remove"), 1); renderFiles(); }
      });
      qform.addEventListener("submit", function (ev) {
        ev.preventDefault();
        if (sending) return;
        status("", "");
        if (!last || last.estimate.nothingToPrice) { status("err", "Add your benchtop sections first, so there is an estimate to send."); return; }
        var ct = contactOf(), errs = contactErrors(ct);
        showErrors(errs);
        if (Object.keys(errs).length) { status("err", "Please check the highlighted details."); return; }
        var bad = files.map(fileProblem).filter(Boolean);
        if (bad.length) { renderFiles(bad.join(" ")); status("err", "Please remove the files that cannot be attached."); return; }
        sending = true;
        var btn = qform.querySelector('[type="submit"]');
        btn.disabled = true;
        var quoteId = newQuoteId();
        var uploads = [];
        status("busy", "Sending your request" + (files.length ? ", uploading your plans" : "") + "&hellip;");
        (files.length ? loadUploadLib() : Promise.resolve(null)).then(function (lib) {
          return files.reduce(function (chain, f, i) {
            return chain.then(function () {
              status("busy", "Uploading " + esc(f.name) + " (" + (i + 1) + " of " + files.length + ")&hellip;");
              var type = FILE_TYPES[extOf(f.name)];
              return lib.upload("plans/" + quoteId + "/" + (i + 1) + "-" + safeName(f.name), f, { access: "private", handleUploadUrl: ENDPOINT + "/api/upload", contentType: type, multipart: f.size > 5 * 1048576 })
                .then(function (r) { uploads.push({ pathname: r.pathname, name: f.name, size: f.size, contentType: type }); });
            });
          }, Promise.resolve());
        }).then(function () {
          status("busy", "Sending your request&hellip;");
          return pdfBlob();
        }).then(function (pdf) {
          var fd = new FormData();
          ["name", "email", "phone", "street", "suburb", "state", "postcode", "message", "website"].forEach(function (k) { fd.append(k, ct[k] || ""); });
          fd.append("quote", JSON.stringify({ state: stateForQuote(), totalIncGst: last.estimate.totalIncGst, priceListDate: D.priceListDate, quoteId: quoteId,
            reopenBase: new URL(configUrl(), window.location.origin).href, uploads: uploads }));
          fd.append("estimate", pdf, "Benchtop-Estimate.pdf");
          return fetch(ENDPOINT + "/api/quote", { method: "POST", body: fd });
        }).then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (body) { return { res: res, body: body }; });
        }).then(function (o) {
          if (!o.res.ok || !o.body.ok) {
            if (o.body.fields) showErrors(o.body.fields);
            throw new Error(o.body.error || "We could not send your request just now.");
          }
          files = [];
          renderFiles();
          status("ok", "<b>Thank you, your benchtop request is with our team.</b> We have emailed you a copy with your estimate PDF. We will come back to you within 2 business days.");
          renderRail();
        }).catch(function (e) {
          var msg = e && e.message && !/^(pdf|upload library missing|Failed to fetch|Load failed|NetworkError)/.test(e.message) ? e.message : "We could not send your request just now. Please check your connection and try again, or email info@customea.com.au.";
          status("err", esc(msg));
        }).then(function () { sending = false; btn.disabled = false; });
      });
    }
    /* the PDF, built in the browser */
    root.addEventListener("click", function (ev) {
      var btn = ev.target.closest("[data-cs-pdf]");
      if (!btn || !last) return;
      btn.disabled = true;
      loadJsPdf(function (ok) {
        if (!ok) { btn.disabled = false; alert("The PDF could not be made just now. Please try again."); return; }
        loadPdfFonts(function () { btn.disabled = false; buildPdf(last, qform ? contactOf() : null, colour(), st.sections).save("Benchtop-Estimate-" + new Date().toISOString().slice(0, 10) + ".pdf"); });
      });
    });
    all();
  }

  /* The PDF in Montserrat: static TTFs from the Montserrat project on jsDelivr, embedded at print time;
     Helvetica if they cannot be fetched. */
  var PDF_FONTS = { normal: "https://cdn.jsdelivr.net/gh/JulietaUla/Montserrat@v7.222/fonts/ttf/Montserrat-Regular.ttf", bold: "https://cdn.jsdelivr.net/gh/JulietaUla/Montserrat@v7.222/fonts/ttf/Montserrat-SemiBold.ttf" };
  var pdfFontData = null;
  var pdfLogo = null;
  function loadPdfLogo() {
    var url = (window.CustomeaStoneQuote || {}).logo;
    if (pdfLogo || !url) return Promise.resolve(pdfLogo);
    return fetch(url).then(function (r) { if (!r.ok) throw new Error("logo"); return r.blob(); }).then(function (b) {
      return new Promise(function (resolve) {
        var fr = new FileReader();
        fr.onload = function () {
          var img = new Image();
          img.onload = function () {
            /* flattened to a JPEG on white: jsPDF stores a transparent PNG uncompressed (a 1 MB PDF) */
            try {
              var w = 900, h = Math.round(w * img.naturalHeight / img.naturalWidth), cv = document.createElement("canvas");
              cv.width = w; cv.height = h;
              var cx = cv.getContext("2d"); cx.fillStyle = "#ffffff"; cx.fillRect(0, 0, w, h); cx.drawImage(img, 0, 0, w, h);
              pdfLogo = { data: cv.toDataURL("image/jpeg", 0.9), type: "JPEG", w: w, h: h };
            } catch (e) { pdfLogo = { data: fr.result, type: "PNG", w: img.naturalWidth, h: img.naturalHeight }; }
            resolve(pdfLogo);
          };
          img.onerror = function () { resolve(null); };
          img.src = fr.result;
        };
        fr.onerror = function () { resolve(null); };
        fr.readAsDataURL(b);
      });
    }).catch(function () { return null; });
  }
  function loadPdfFonts(cb) {
    if (pdfFontData) return loadPdfLogo().then(function () { cb(pdfFontData); });
    var b64 = function (buf) { var s = "", a = new Uint8Array(buf); for (var i = 0; i < a.length; i += 8192) s += String.fromCharCode.apply(null, a.subarray(i, i + 8192)); return btoa(s); };
    Promise.all([fetch(PDF_FONTS.normal), fetch(PDF_FONTS.bold)]).then(function (rs) {
      if (!rs[0].ok || !rs[1].ok) throw new Error("font");
      return Promise.all([rs[0].arrayBuffer(), rs[1].arrayBuffer()]);
    }).then(function (bufs) { pdfFontData = { normal: b64(bufs[0]), bold: b64(bufs[1]) }; }).catch(function () {}).then(loadPdfLogo).then(function () { cb(pdfFontData); });
  }
  function loadJsPdf(cb) {
    if (window.jspdf && window.jspdf.jsPDF) return cb(true);
    var s = document.createElement("script");
    s.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
    s.onload = function () { cb(!!(window.jspdf && window.jspdf.jsPDF)); };
    s.onerror = function () { cb(false); };
    document.head.appendChild(s);
  }
  /* The customer's estimate PDF (download button and the copy emailed to them).
     v9: the Customea logo and the gold title on top; every block is measured first and laid out on A4
     so a normal job (two sections, seven job lines) fits one page; a longer job spills to page 2, a
     heading always stays with its first row and page 2 never holds a single orphan line. No ex-GST
     working here (that stays in the team email); body text never below 9 pt. */
  function buildPdf(r, ct, c, sections) {
    var doc = new window.jspdf.jsPDF({ unit: "mm", format: "a4" });
    var FONT = "helvetica";
    if (pdfFontData) {
      doc.addFileToVFS("Montserrat-Regular.ttf", pdfFontData.normal); doc.addFont("Montserrat-Regular.ttf", "Montserrat", "normal");
      doc.addFileToVFS("Montserrat-SemiBold.ttf", pdfFontData.bold); doc.addFont("Montserrat-SemiBold.ttf", "Montserrat", "bold");
      FONT = "Montserrat";
    }
    var est = r.estimate;
    var X = 16, R = 194, TOP = 14, BOTTOM = 284, LABEL_W = 138;
    var INK = [26, 26, 26], MUTE = [110, 106, 100], GOLD = [191, 169, 124];
    var lh = function (pt) { return pt * 0.3528 * 1.32; };          /* line height in mm */
    var wrap = function (txt, pt, style, w) { doc.setFont(FONT, style || "normal"); doc.setFontSize(pt); return doc.splitTextToSize(String(txt), w || R - X); };
    var items = [];
    /* a block: its height, how to draw it at y, and whether it must stay on the same page as the next one */
    function block(h, draw, keepNext) { items.push({ h: h, draw: draw, keep: !!keepNext }); }
    function text(txt, pt, style, colour, gap) {
      var lines = wrap(txt, pt, style);
      block(lines.length * lh(pt) + (gap || 0), function (y) {
        doc.setFont(FONT, style || "normal"); doc.setFontSize(pt); doc.setTextColor.apply(doc, colour || INK);
        lines.forEach(function (l, i) { doc.text(l, X, y + lh(pt) * (i + 0.78)); });
      });
    }
    function row(label, amount, opt) {
      opt = opt || {};
      var pt = opt.pt || 9.5, style = opt.bold ? "bold" : "normal";
      var lines = wrap(label, pt, style, LABEL_W);
      var h = lines.length * lh(pt) + 1.6;
      block(h, function (y) {
        doc.setDrawColor(236, 230, 220); doc.setLineWidth(0.2); doc.line(X, y, R, y);
        doc.setFont(FONT, style); doc.setFontSize(pt); doc.setTextColor.apply(doc, INK);
        lines.forEach(function (l, i) { doc.text(l, X, y + 0.8 + lh(pt) * (i + 0.78)); });
        doc.text(String(amount), R, y + 0.8 + lh(pt) * 0.78, { align: "right" });
      }, opt.keepNext);
    }
    function heading(txt) {
      block(lh(9.5) + 3.2, function (y) {
        doc.setFont(FONT, "bold"); doc.setFontSize(9.5); doc.setTextColor.apply(doc, GOLD);
        doc.text(txt.toUpperCase(), X, y + 2 + lh(9.5) * 0.78, { charSpace: 0.3 });
      }, true);
    }
    function gap(h) { block(h, function () {}); }

    /* header: logo top left, the gold title under it, then who and when */
    var d = new Date();
    var logoW = 44, logoH = pdfLogo ? logoW * pdfLogo.h / pdfLogo.w : 0;
    block((pdfLogo ? logoH * 0.86 : 0) + lh(20) + 2, function (y) {
      /* the logo file has white margins (about 6% left, 18% top): line its letters up with the text */
      if (pdfLogo) doc.addImage(pdfLogo.data, pdfLogo.type, X - logoW * 0.055, y - logoH * 0.16, logoW, logoH);
      var ty = y + (pdfLogo ? logoH * 0.86 : 0);
      doc.setFont(FONT, "bold"); doc.setFontSize(20); doc.setTextColor.apply(doc, GOLD);
      doc.text("Benchtop Estimate", X, ty + lh(20) * 0.8);
    });
    text("customea.com.au  ·  info@customea.com.au", 9, "normal", MUTE);
    text("Prepared " + d.toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" }) + ". Prices from Caesarstone's list dated " + D.priceListDate.split("-").reverse().join("/") + ". All prices incl. GST.", 9, "normal", MUTE);
    if (ct && ct.name) text("Prepared for " + ct.name + (ct.suburb ? ", " + ct.suburb + " " + ct.state + " " + ct.postcode : ""), 9, "normal", MUTE);
    gap(3);
    text("Caesarstone " + c.code + " " + c.name + ", " + seriesOf(c) + ", " + r.thicknessMm + " mm, " + incAud(c.ratesExGst[r.thicknessMm]) + " per m²", 11, "bold");
    text("Edge: " + E.edgeOption(r.edge, r.input.material).label + ", " + incAud(E.edgeOption(r.edge, r.input.material).pricePerMExGst) + " per metre", 9.5);
    var pr = pricedRows(r, sections);
    if (pr) {
      gap(1.5);
      heading("Sections");
      pr.sections.forEach(function (sx) { row(sx.label + ": " + sx.detail, aud(sx.inc)); });
      gap(1.5);
      heading("Whole job");
      pr.job.forEach(function (l, i) { row(l.label + (l.qty ? " (" + l.qty + ")" : ""), aud(l.inc), { keepNext: i === pr.job.length - 1 }); });
      block(lh(9.5) * 2 + lh(12) + 5, function (y) {
        doc.setDrawColor.apply(doc, GOLD); doc.setLineWidth(0.5); doc.line(X, y + 0.6, R, y + 0.6); doc.setLineWidth(0.2);
        doc.setFont(FONT, "normal"); doc.setFontSize(9.5); doc.setTextColor.apply(doc, MUTE);
        doc.text("Includes GST", X, y + 2 + lh(9.5) * 0.8); doc.text(aud(pr.gst), R, y + 2 + lh(9.5) * 0.8, { align: "right" });
        doc.setFont(FONT, "bold"); doc.setFontSize(12); doc.setTextColor.apply(doc, INK);
        var ty = y + 3 + lh(9.5) + lh(12) * 0.85;
        doc.text("Estimate incl. GST", X, ty); doc.text(aud(pr.total), R, ty, { align: "right" });
      });
    }
    est.notes.forEach(function (n) { text(m2(n), 9, "bold", INK, 1); });
    gap(3);
    var foot1 = wrap(DISCLAIMER, 9.5, "bold"), foot2 = wrap("A 3 m² minimum and the site template fee apply to every job. Installation is by a certified Caesarstone stonemason after a check measure, once your cabinets are in.", 9, "normal");
    block(foot1.length * lh(9.5) + foot2.length * lh(9) + 1, function (y) {
      doc.setFont(FONT, "bold"); doc.setFontSize(9.5); doc.setTextColor.apply(doc, INK);
      foot1.forEach(function (l, i) { doc.text(l, X, y + lh(9.5) * (i + 0.78)); });
      var y2 = y + foot1.length * lh(9.5) + 1;
      doc.setFont(FONT, "normal"); doc.setFontSize(9); doc.setTextColor.apply(doc, MUTE);
      foot2.forEach(function (l, i) { doc.text(l, X, y2 + lh(9) * (i + 0.78)); });
    });

    /* pagination: "keep" blocks travel with the next one; page 2 never starts with a lone last group */
    var groups = [];
    items.forEach(function (it) {
      var g = groups.length && groups[groups.length - 1].open ? groups[groups.length - 1] : null;
      if (!g) { g = { h: 0, items: [], open: false }; groups.push(g); }
      g.items.push(it); g.h += it.h; g.open = it.keep;
    });
    var CONT = lh(10) + 3;
    var pages = [[]], used = 0, room = BOTTOM - TOP;
    groups.forEach(function (g) {
      if (used + g.h > room && pages[pages.length - 1].length) { pages.push([]); used = 0; room = BOTTOM - TOP - CONT; }
      pages[pages.length - 1].push(g); used += g.h;
    });
    var last = pages[pages.length - 1], prev = pages[pages.length - 2];
    if (prev && last.length === 1 && last[0].items.length === 1 && prev.length > 1) last.unshift(prev.pop());
    pages.forEach(function (page, pi) {
      if (pi > 0) {
        doc.addPage();
        doc.setFont(FONT, "bold"); doc.setFontSize(10); doc.setTextColor.apply(doc, GOLD);
        doc.text("Benchtop Estimate, continued", X, TOP + lh(10) * 0.78);
      }
      var y = TOP + (pi > 0 ? CONT : 0);
      page.forEach(function (g) { g.items.forEach(function (it) { it.draw(y); y += it.h; }); });
    });
    doc.setTextColor.apply(doc, INK);
    return doc;
  }

  function boot() {
    document.querySelectorAll("[data-stone-collection]").forEach(initCollection);
    document.querySelectorAll("[data-stone-colour]").forEach(initColour);
    document.querySelectorAll("[data-stone-configurator]").forEach(initConfigurator);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
